import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: "not-found",
    styleUrls: ["./not-found.component.scss"],
    templateUrl: "./not-found.component.html",
    imports: [RouterLink]
})
export class NotFoundComponent {}
